import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { useTwilioAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/TwilioAccountProvider/useTwilioAccount";
import { SelectPhoneNumberDialog } from "../../../../components/SelectPhoneNumberDialog";
import { useTwilioPhoneNumberAssociationFlow } from "../../hooks/useTwilioPhoneNumberAssociationFlow";
import { ReactComponent as ChatIcon } from "../../assets/chat.svg";
import { ReactComponent as SettingsIcon } from "../../../../assets/settings.svg";

export const AssociatedPhoneSection: React.FC = () => {
  const { t } = useTranslations();
  const { twilioAccount, changeTwilioPhone, isChangingTwilioPhone } =
    useTwilioAccount();

  const {
    isDialogOpen,
    isListingPhoneNumbers,
    phoneNumbers,
    startFlow,
    closeDialog,
    associate,
  } = useTwilioPhoneNumberAssociationFlow({
    associatePhoneNumber: (phoneNumber) =>
      changeTwilioPhone({
        phone_number: phoneNumber.phone_number,
        phone_number_sid: phoneNumber.sid,
      }),
    successMessage: t({
      id: "client-support-page.twilio-phone-number-updated",
      defaultMessage: "Phone number updated successfully",
    }),
  });

  const initialSelectedSid = phoneNumbers.find(
    (item) => item.phone_number === twilioAccount?.phone_num
  )?.sid;

  const handleManage = () => {
    if (!twilioAccount) {
      return;
    }
    startFlow({ sid: twilioAccount.sid, token: null });
  };

  return (
    <>
      <div className="flex flex-col gap-3 rounded-3xl border border-solid border-dark-100 bg-white p-8 shadow-[0_2px_4px_rgba(0,0,0,0.08)] max-lg:p-5">
        <span className="font-secondary text-sm text-dark-800">
          {t({
            id: "client-support-page.twilio-associated-account",
            defaultMessage: "Associated phone number:",
          })}
        </span>
        <div className="flex items-center justify-between gap-4 rounded-2xl border border-solid border-dark-100 px-4 py-3">
          <div className="flex items-center gap-3">
            <ChatIcon className="h-5 w-5 shrink-0" />
            <span className="font-secondary text-base font-medium text-[#383838]">
              {twilioAccount?.phone_num}
            </span>
          </div>
          <Button
            variant="tertiary"
            className="h-10 w-[120px]"
            iconStart={<SettingsIcon className="h-4 w-4" />}
            isDisabled={isListingPhoneNumbers}
            onClick={handleManage}
          >
            {t({
              id: "client-support-page.twilio-manage",
              defaultMessage: "Manage",
            })}
          </Button>
        </div>
      </div>

      <SelectPhoneNumberDialog
        isOpen={isDialogOpen}
        isLoading={isListingPhoneNumbers}
        phoneNumbers={phoneNumbers}
        initialSelectedSid={initialSelectedSid}
        isAssociating={isChangingTwilioPhone}
        onAssociate={associate}
        onClose={closeDialog}
      />
    </>
  );
};
